import { AppBar, Container, Toolbar, Button } from '@mui/material'
import {
  ViewList as ViewListIcon,
  ConfirmationNumber as TicketIcon,
  CleaningServices as CleanupIcon,
} from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const ErrorTrackerNav = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <AppBar position="sticky" elevation={0} sx={(theme) => ({ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, top: 0, mb: 0, borderBottom: `1px solid ${theme.palette.divider}` })}>
      <Container maxWidth="xl" disableGutters>
        <Toolbar disableGutters variant="dense">
          <Button
            color="inherit"
            startIcon={<ViewListIcon />}
            onClick={() => navigate('/error-tracker')}
            sx={{ ml: 2 }}
          >
            {t('common.errorsTrackerTool')}
          </Button>
          <Button
            color="inherit"
            startIcon={<TicketIcon />}
            onClick={() => navigate('/error-tracker/tickets')}
            sx={{ ml: 2 }}
          >
            {t('menu.tickets')}
          </Button>
          <Button
            color="inherit"
            startIcon={<CleanupIcon />}
            onClick={() => navigate('/error-tracker/cleanup')}
            sx={{ ml: 2 }}
          >
            {t('menu.cleanup')}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default ErrorTrackerNav
